import { SelectBoxOption, TagInfo } from "../interfaces";
import { useAppDispatch } from "../redux";
import { openDialog } from "../redux/slices/dialog";
import { AddEditTags } from "../screens/tags/tagListing/addEditTags";

export const useCreateTag = () => {
    const dispatch = useAppDispatch();

    const createOrUpdateTag = (refetch: () => void, selectedTG: SelectBoxOption, isEdit?: boolean) => {
        dispatch(openDialog({
            title: `${isEdit ? "Update" : "Create"} Tag`,
            hideNegativeBtn: true,
            hidePositiveBtn: true,
            body: <AddEditTags isEdit={isEdit ?? false} data={isEdit ? selectedTG : null} refetch={refetch} selectedTagGroup={selectedTG?.label ? selectedTG : { label: (selectedTG?.options?.[0] as unknown as TagInfo)?.tag_group_name, value: selectedTG?.options?.[0]?.tag_group_id as string }} />
        }));
    }

    return createOrUpdateTag;
};
